import { crewCustomerApi } from 'corso-types';
import { zfd } from 'zod-form-data';
import api from '~/utils/api';
import { makeLineItemClaimActionWithReason } from '~/utils/routing';

export const ACTION_KEY = 'event';
const schema = zfd.formData({
  [ACTION_KEY]: zfd.json(
    crewCustomerApi['/:storefrontId/automations/after-reason-selection'].post
      .request.body,
  ),
});

export const { action, useActionResult: useFollowUpActionResult } =
  makeLineItemClaimActionWithReason(({ formData, context }, appState) => {
    const result = schema.safeParse(formData);

    if (!result.success) {
      return new Error('Malformed form data', {
        cause: {
          error: result.error,
          entries: Array.from(Object.entries(formData)),
        },
      });
    }

    const { claim, order } = context;
    const item = order.lineItems.find(
      (lineItem) => lineItem.id === claim.lineItem.id,
    );

    if (!item) {
      return new Error('Line item not found on order.');
    }

    return api
      .confirmAfterReasonSelection({
        params: { storefrontId: context.settings.storefrontId },
        body: result.data.event,
        query: {
          lineItemIdFromPlatform: claim.lineItem.idFromPlatform,
          quantity: claim.quantity,
          lineItemId: claim.lineItem.id,
          reasonId: claim.reason.id,
          claimType: claim.claimType,
          reasonCategoryCode: claim.reason.category,
          ...(claim.reason.detail && {
            reasonDetailId: claim.reason.detail.id,
          }),
        },
      })
      .then(() => {
        // item not eligible for return
        appState.dispatch(appState.actions.invalidateLineItem(claim.id));

        return {
          ok: true,
        };
      })
      .catch(() => ({ ok: false }));
  });
